/**
 * Ссылка «поделиться списком покупок»: `?list=` поверх контракта QR-ссылок
 * (ADR 0004, аддитивный параметр). Открывший видит тот же список без
 * аккаунтов и серверов — список едет в самой ссылке.
 */
import { venueUrl } from '@app/brand'
import { serializeList } from './shopping'

export function shareListUrl(venueId: string, keys: readonly string[]): string {
  return venueUrl(venueId, { list: serializeList(keys) })
}
